module.exports = __webpack_public_path__ + "static/img/grow_award_06.37a0755.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/mentoring/prentice/grow_award_06.png
// module id = +wSY
// module chunks = 1